import {
  GetState,
  RegisterStateUpdatedListener,
  UnregisterStateUpdatedListener,
} from "../state/State.js";

export class ConnectedHTMLElement extends HTMLElement {
  state;

  constructor() {
    super();
    this.state = GetState();
    this.registerStateEventListeners();
  }

  render() {
    console.info("🧙‍♂️[ConnectedHTMLElement] render");
  }

  updateStateListener(e) {
    const oldState = { ...this.state };
    // console["log"](
    //   "🐵 ConnectedHTMLElement: updateStateListener: ",
    //   e.detail.state,
    //   e.detail.old,
    //   oldState
    // );
    this.state = e.detail.state;
    this.stateUpdated(this.state, oldState);
  }

  registerStateEventListeners() {
    RegisterStateUpdatedListener(this.updateStateListener.bind(this));
  }

  stateUpdated(newState, oldState) {
    console.info("🧙‍♂️[ConnectedHTMLElement] stateUpdated", newState, oldState);
  }

  disconnectedCallback() {
    // unregister events
    UnregisterStateUpdatedListener(this.updateStateListener.bind(this));
  }
}
